import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollTop from "./components/ScrollTop";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Couples from "./pages/Couples";
import Groups from "./pages/Groups";
import Proposals from "./pages/Proposals";
import EventStyling from "./pages/EventsStyling";
import Booking from "./pages/Booking";
import Terms from "./pages/Terms";
import FrequentlyAskedQuestions from "./pages/FrequentlyAskedQuestions";
import Additions from "./components/Additions";
import Login from "./pages/Login";
import AdminRoute from "./components/AdminRoute";
import Dashboard from "./pages/Dashboard";
import Bookings from "./pages/Bookings";
import BookingsDetails from "./pages/BookingsDetails";
import Invoice from "./pages/Invoice";
import UsersDetails from "./pages/UsersDetails";
import RegisterAdmin from "./pages/RegisterAdmin";
import Users from "./pages/Users";
import Logout from "./pages/Logout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <div className="app__container">
        <ToastContainer />
        <NavBar />
        <div className="app__main--content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/couples" element={<Couples />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/proposals" element={<Proposals />} />
            <Route path="/special-events" element={<EventStyling />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/faq" element={<FrequentlyAskedQuestions />} />
            <Route path="/additions" element={<Additions />} />
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route element={<AdminRoute />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route path="bookings" element={<Bookings />} />
                <Route path="bookings/:id" element={<BookingsDetails />} />
                <Route path="bookings/invoice/:id" element={<Invoice />} />
                <Route path="users" element={<Users />} />
                <Route path="users/:id" element={<UsersDetails />} />
                <Route path="registerAdmin" element={<RegisterAdmin />} />
                <Route path="logout" element={<Logout />} />
              </Route>
            </Route>
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
